module.exports = __webpack_public_path__ + "img/car_shina2_31.c29727a8.jpg";